/**
 * Inline confirmation — button swaps to "Are you sure? Yes / Cancel" (no browser popups).
 */

import React, { useState } from 'react';

const defaultConfirmStyle = {
  padding: '0.5rem 1rem',
  background: '#dc3545',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '0.85rem',
  fontWeight: '500',
};

const defaultCancelStyle = {
  padding: '0.5rem 1rem',
  background: '#6c757d',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '0.85rem',
};

export default function InlineConfirm({
  message = 'Are you sure?',
  onConfirm,
  onCancel,
  disabled = false,
  loading = false,
  buttonLabel,
  buttonStyle = {},
  buttonClassName = '',
  confirmLabel = 'Yes',
  cancelLabel = 'Cancel',
  loadingLabel,
  confirmStyle = {},
}) {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '0.9rem' }}>{message}</span>
        <button
          type="button"
          disabled={loading}
          onClick={async () => {
            await onConfirm?.();
            setConfirming(false);
          }}
          style={{
            ...defaultConfirmStyle,
            ...confirmStyle,
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? (loadingLabel || '...') : confirmLabel}
        </button>
        <button
          type="button"
          disabled={loading}
          onClick={() => {
            setConfirming(false);
            onCancel?.();
          }}
          style={defaultCancelStyle}
        >
          {cancelLabel}
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => setConfirming(true)}
      className={buttonClassName || undefined}
      style={buttonStyle}
    >
      {buttonLabel}
    </button>
  );
}
